import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import southShop from '../assets/southShop.png';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signIn(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Image with Gradient Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${southShop})`, // Correct usage of the imported image
        }}
      >
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 25%, rgba(243, 244, 246, 1) 100%)',
          }}
        />
      </div>

      {/* 45-Degree Diagonal Section */}
      <div
        className="absolute inset-0 hidden md:block"
        style={{
          background: 'rgba(99, 102, 241, 0.1)', // Indigo with opacity
          clipPath: 'polygon(0 0, 100% 0, 0 100%)', // Creates a 45-degree diagonal from top-left to bottom-right
        }}
      />

      {/* Login Form */}
      <div className="relative bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 hover:shadow-3xl">
        <h2 className="text-3xl font-extrabold mb-6 text-center text-gray-900 tracking-tight">
          Login Now
        </h2>
        {error && (
          <p className="text-red-500 mb-4 text-center bg-red-50 py-2 rounded-lg">
            {error}
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label
              className="block text-gray-700 mb-2 text-sm font-medium"
              htmlFor="email"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md"
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 mb-2 text-sm font-medium"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md"
              placeholder="Enter your password"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-indigo-600 text-white p-3 rounded-lg hover:bg-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            Sign In
          </button>
        </form>
        <p className="mt-6 text-center text-gray-600 text-sm">
          Don't have an account? The ACA Portal is used by Customers to Track Orders. {' '}
          <span></span>
          <Link
            to="https://www.acamachine.com/contact"
            className="text-indigo-600 hover:text-indigo-800 font-medium transition duration-200"
          >
            Reach out to a Team Member today for access.
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;